<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="blockquote-container prose with-attribution">
<blockquote class="prose with-attribution">
<div class="paragraph-and-attribution">
<p class="first blockquote-content blockquote-content-prose blockquote-position-first epigraph-content">“Or what woman, having ten silver coins, if she loses one coin, does not light a lamp and sweep the house and seek diligently until she finds it?”</p>
<p class="blockquote-attribution blockquote-position-last"><span class="case-upper">LUKE 15:8</span></p>
</div>
</blockquote>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?38d28b77